module.exports = __webpack_public_path__ + "static/media/products.463155e6.svg";